import styled from "styled-components";

const ProductDetail = styled.div`
    font-size: 20px;
    margin-top: 0.8em;
    color: #333;
`;
export default ProductDetail;
